module.exports = __webpack_public_path__ + "22a1fbb0ccde9aa53202dc4697b953a1.svg";